<div *ngIf="!isLoading" class="renderer-pinned-container"
    [ngSwitch]="templateId">
  <ng-template [ngSwitchCase]="0">
    <span class="renderer-pinned-default">{{ cellValue }}</span>
  </ng-template>
  <ng-template [ngSwitchCase]="1">
    <i class="fa fa-square-o lfwms-checkbox fa-disabled"></i>
  </ng-template>
</div>